import { useId } from 'react';

import { useController } from 'react-hook-form';

import ErrorMessage from '@/components/ErrorMessage';
import { cn } from '@/utils';

import Input from '../Input';
import Label from './Label';
import { parseMessage } from './utils';

function FormInput({
	name,
	label,
	id,
	control,
	disabled,
	required,
	errorMessageProps,
	hidden = false,
	children,
	className,
	inputClassName,
	StartIcon,
	...props
}) {
	const { field, fieldState } = useController({ name, control, disabled });
	const generatedId = useId();
	const parsedId = id ?? generatedId;

	return (
		<div
			className={cn(
				'form-input relative w-full',
				hidden && 'hidden',
				className
			)}
		>
			{label && (
				<Label htmlFor={parsedId}>{`${label}${required ? '*' : ''}`}</Label>
			)}
			<div className={StartIcon && 'flex items-center'}>
				{StartIcon && (
					<StartIcon
						className="pointer-events-none absolute z-10 ml-3 h-5 w-5 flex-shrink-0 text-black"
						width="20"
						height="20"
					/>
				)}
				<Input
					id={parsedId}
					error={fieldState.invalid}
					className={cn(inputClassName, StartIcon && 'pl-10')}
					{...field}
					{...props}
				/>
			</div>

			{fieldState.error?.message && (
				<ErrorMessage {...errorMessageProps}>
					{parseMessage(fieldState.error.message)}
				</ErrorMessage>
			)}
			{children}
		</div>
	);
}

export default FormInput;
